import { render, staticRenderFns } from "./RegionList.vue?vue&type=template&id=07e9854a&scoped=true&"
import script from "./RegionList.vue?vue&type=script&lang=js&"
export * from "./RegionList.vue?vue&type=script&lang=js&"
import style0 from "./RegionList.vue?vue&type=style&index=0&id=07e9854a&lang=scss&scoped=true&"
import style1 from "./RegionList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e9854a",
  null
  
)

export default component.exports